import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { togglingAppMode } from '../../../../../modules/merchants/store/actions/action.creators';
import { getLiveMerchantByEmail } from '../../../../../modules/merchants/store/operators/get_live_merchant_by_email';

const ToggleButton: FC = () => {
    const { toggledAppMode, getLiveMerchantSuccess } = useSelector(({ Merchants }: any) => Merchants);

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch(getLiveMerchantByEmail());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggledAppMode]);

    const handleToggle = () => {
        if (getLiveMerchantSuccess) {
            const userMode = localStorage.getItem('modeType');
            const selectState = userMode === 'LIVE' ? 'TEST' : 'LIVE';

            dispatch(togglingAppMode({ mode: selectState }));
        } else {
            history.push('go-live');
        }
    };

    return (
        <div className="oi-nav__link  oi-nav__link--position u-cursor" onClick={handleToggle}>
            <div className="oi-switch u-cursor">
                <div className={toggledAppMode === 'Test Mode' ? 'switch-btn' : 'u-hide'}>
                    <div className="off-btn" />
                </div>

                <div className={toggledAppMode === 'Live Mode' ? 'switch-btn' : 'u-hide'}>
                    <div className="on-btn" />
                </div>
            </div>

            {toggledAppMode}
        </div>
    );
};

export default ToggleButton;
